import { assetCatalogResult, assetDetailResult } from '../consumer/asset-contract';
export class AssetWireError extends Error {
  constructor() {
    super('Local asset Wire Invalid');
    this.name = 'AssetWireError';
  }
}
export function parseLocalAssetCatalogWire(value: unknown) {
  try {
    return assetCatalogResult(value);
  } catch {
    throw new AssetWireError();
  }
}
export function parseLocalAssetDetailWire(value: unknown, expectedId: string) {
  try {
    return assetDetailResult(value, expectedId);
  } catch {
    throw new AssetWireError();
  }
}
